import React, {useCallback, useMemo, useState} from 'react';

import {useTheme} from '../../theme';
import {BaseEditor} from './BaseEditor';
import {
  mapEditorToBaseProperties,
  mapContainerToBaseProperties,
} from './functions';

import {EditorProps} from './types';

export const Editor: React.FC<EditorProps> = ({
  onChange,
  onFocus,
  onBlur,
  rows,
  ...props
}) => {
  const [focus, setFocus] = useState(false);
  const theme = useTheme();

  const propsWithDefaults = useMemo(() => {
    const {round = false, state = 'Default', clear = false, ...rest} = props;
    return {
      round,
      state,
      clear,
      ...rest,
    };
  }, [props]);

  const {value, placeholder} = propsWithDefaults;

  const handleOnFocus = useCallback(() => {
    setFocus(true);
    onFocus && onFocus();
  }, [onFocus]);

  const handleOnBlur = useCallback(() => {
    setFocus(false);
    onBlur && onBlur();
  }, [onBlur]);

  const baseEditorContainerProps = useMemo(
    () => mapContainerToBaseProperties(theme, focus, propsWithDefaults),
    [theme, focus, propsWithDefaults],
  );

  const baseEditorProps = useMemo(
    () => mapEditorToBaseProperties(theme, propsWithDefaults),
    [theme, propsWithDefaults],
  );

  return (
    <BaseEditor
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      rows={rows}
      {...baseEditorProps}
      {...baseEditorContainerProps}
    />
  );
};
